var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundGradientSpecialist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1539,
    height: 680,
    viewBox: "0 0 1539 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4526_208455)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 438.554,
    ry: 640.358,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 906.406 667.879)",
    fill: "url(#paint0_linear_4526_208455)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4526_208455",
    x: 0.539062,
    y: -267.578,
    width: 1811.73,
    height: 1870.91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 186,
    result: "effect1_foregroundBlur_4526_208455"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4526_208455",
    x1: 438.554,
    y1: 0,
    x2: 438.554,
    y2: 1280.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGradientSpecialist);
export default __webpack_public_path__ + "static/media/background-gradient-specialist.03e4cfc3cd8313cdfa3df1b32de64f04.svg";
export { ForwardRef as ReactComponent };